export default {
  paged: {
    select: 'id,isActive,name,scope,kind,category',
    searchSelect: ['name'],
    orderBy: 'name asc',
  },
  itemDetail: {
    expand: {
      exclusiveCompany: {
        select: 'commercialName',
      },
    },
  },
};
